var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"appAudio",staticClass:"hidden",attrs:{"controls":"","src":_vm.audio.src,"loop":"true","preload":"auto"}},[_vm._v(" Your browser does not support the "),_c('code',[_vm._v("audio")]),_vm._v(" element. ")])}
var staticRenderFns = []

export { render, staticRenderFns }